// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coach-header {
    width: 100%;
    background-color: var(--white);
    padding-top: 0px;
    padding-right: 0px;
    padding-left: 0px;
}

.coach-header .left-box>p:nth-child(1) {
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
    font-size: 22px;
    line-height: 32px;
    letter-spacing: -0.44px;
}

.coach-header .left-box>p:nth-child(2) {
    color: var(--disbaled-color);
    font-family: var(--inter-Medium500);
    font-size: 16px;
    line-height: 21px;
}

.add-coach-button {
    min-width: 157px;
    height: 35px;
    display: flex;
    padding: 7px 23px 8px 23px;
    justify-content: center;
    align-items: center;
    /* flex-shrink: 0; */
    border-radius: 6px;
    background: #F4F7FE;
    border: none;
}

.add-coach-button:hover {
    /* background: var(--background-color1); */
    opacity: 0.8;
}

.buttonClassforQuestion {
    width: 164px;
    padding: 7px 18px 8px 17px;
}

.add-coach-button>img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
}

.add-coach-button>p {
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
    font-size: 10px;
    line-height: normal;
    text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/components/headers/caochTableHead/CaochTableHead.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;IACnC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B","sourcesContent":[".coach-header {\n    width: 100%;\n    background-color: var(--white);\n    padding-top: 0px;\n    padding-right: 0px;\n    padding-left: 0px;\n}\n\n.coach-header .left-box>p:nth-child(1) {\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n    font-size: 22px;\n    line-height: 32px;\n    letter-spacing: -0.44px;\n}\n\n.coach-header .left-box>p:nth-child(2) {\n    color: var(--disbaled-color);\n    font-family: var(--inter-Medium500);\n    font-size: 16px;\n    line-height: 21px;\n}\n\n.add-coach-button {\n    min-width: 157px;\n    height: 35px;\n    display: flex;\n    padding: 7px 23px 8px 23px;\n    justify-content: center;\n    align-items: center;\n    /* flex-shrink: 0; */\n    border-radius: 6px;\n    background: #F4F7FE;\n    border: none;\n}\n\n.add-coach-button:hover {\n    /* background: var(--background-color1); */\n    opacity: 0.8;\n}\n\n.buttonClassforQuestion {\n    width: 164px;\n    padding: 7px 18px 8px 17px;\n}\n\n.add-coach-button>img {\n    width: 20px;\n    height: 20px;\n    margin-right: 4px;\n}\n\n.add-coach-button>p {\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n    font-size: 10px;\n    line-height: normal;\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
